<template>
  <div v-if="!whatCateogryRatingPresenter.hasData.value" class="w-full h-full flex justify-center items-center">
    {{ $t('message.noData') }}
  </div>
  <VueApexCharts
    v-else
    height="100%"
    :options="whatCateogryRatingPresenter.chartOptions.value"
    :series="whatCateogryRatingPresenter.chartSeries.value"
    type="radar"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted, SetupContext } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { dashboardTargetColor, whatCategoryRatingChartColor } from '@/domain/value_objects/color/ColorList'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useDashboardModalStatePresenter } from '@/presentation/composables/dashboard/useDashboardModalStatePresenter'
import { useWhatCategoryRatingPresenter } from '@/presentation/composables/dashboard/useWhatCategoryRatingPresenter'

export default defineComponent({
  components: { VueApexCharts },
  setup(props, ctx: SetupContext) {
    const dashboardModalStatePresenter = useDashboardModalStatePresenter()
    const whatCateogryRatingPresenter = useWhatCategoryRatingPresenter()
    const { isLightMode, displayLanguage } = useConfigStatePresenter()

    const initChart = () => {
      whatCateogryRatingPresenter.initChart(
        dashboardModalStatePresenter.dashboardUserList.value,
        whatCategoryRatingChartColor,
        dashboardTargetColor,
        dashboardModalStatePresenter.dashboardProgramLanguage.value,
        displayLanguage.value,
        isLightMode()
      )
    }

    onMounted(() => {
      // initChart()
    })

    return {
      initChart,
      whatCateogryRatingPresenter
    }
  }
})
</script>

<style lang="postcss" scoped></style>
